import React from 'react';

const StoppageEvent = ({ event }) => {
    const reason = event.details?.reason || 'N/A';

    return (
        <div className="flex items-center mb-2">
            <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
            <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
            <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">Reason:</span>
            <span className="text-sm text-gray-900">{reason}</span>
        </div>
    );
};

export default StoppageEvent;
